import { UserPen } from 'lucide-react';

import { NodeShell } from './NodeShell';

interface UpdateContactNodeData {
  label: string;
  contactId?: string;
  phone?: string;
  email?: string;
  fetchContactData?: boolean;
  mappings?: Array<{ field: string; value: string }>;
  dataBody?: string | null;
}

export const UpdateContactNode = ({
  data,
  selected,
}: {
  data: UpdateContactNodeData;
  selected?: boolean;
}) => {
  const mappingCount = data.mappings?.length ?? 0;
  const hasBody = !!data.dataBody;
  const lookupParts = [
    data.contactId && `id: ${data.contactId}`,
    data.phone && `phone: ${data.phone}`,
    data.email && `email: ${data.email}`,
  ].filter(Boolean);

  const action = data.fetchContactData
    ? 'Fetch only'
    : mappingCount > 0
      ? `${mappingCount} field${mappingCount !== 1 ? 's' : ''}${hasBody ? ' + JSON body' : ''}`
      : hasBody
        ? 'JSON body'
        : 'Creates if not found';

  return (
    <NodeShell
      type="update_contact"
      icon={<UserPen size={16} />}
      label={data.label}
      subtitle={lookupParts.length > 0 ? `${lookupParts.join(' · ')} · ${action}` : action}
      selected={selected}
    />
  );
};
